import { render } from "./PopArea.vue?vue&type=template&id=f929fdf0"
import script from "./PopArea.vue?vue&type=script&lang=js"
export * from "./PopArea.vue?vue&type=script&lang=js"

import "./PopArea.vue?vue&type=style&index=0&id=f929fdf0&lang=css"

import exportComponent from "E:\\Projects\\New folder\\New folder\\Olt Care\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__